import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Button } from '@mui/material';
import { styled } from '@mui/system';
import { isEmpty, round } from 'lodash';

import Color from '@tool/color';
import { CloseIcon20 } from '@styled/icon';
import { newRate } from '@tool/index';
import moDemandPdf from '../store';

interface IProps {
  list: any;
}
interface IState {}

const HotRoleTable = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const { list } = props;
  const titleList = [
    '细分职能',
    '招聘量',
    '招聘量排名',
    '招聘量环比变化率',
    '招聘量环比变化率排名',
    '招聘薪酬',
    '招聘薪酬排名',
    '招聘薪酬环比变化率',
    '招聘薪酬环比变化率排名',
  ];

  useEffect(() => {
    return () => {};
  }, []);

  return (
    <section className="hot-role-table">
      <section className="title">
        {titleList.map((res: any, r: any) => {
          return (
            <p key={r}>
              <b>{res}</b>
            </p>
          );
        })}
      </section>
      <section className="table-content">
        {list?.map((res: any, i: any) => {
          return (
            <p key={i}>
              <span>{res.category_3}</span>
              <span>{res.amount?.toLocaleString()}</span>
              <span>{res.amount_rank}</span>
              <span>{`${round(res.amount_change * 100, 1)}%`}</span>
              <span>{res.amount_change_rank}</span>
              <span>{res.salary?.toLocaleString()}</span>
              <span>{res.salary_rank}</span>
              <span>{`${round(res.salary_change * 100, 1)}%`}</span>
              <span>{res.salary_change_rank}</span>
            </p>
          );
        })}
      </section>
    </section>
  );
};

export default observer(HotRoleTable);
